import { _ as e } from "./tslib.es6-7f1b1220.js";
import { d as t, N as i, a, r, b as n, c as o, u as l, h as d, n as p } from "./lit-element-161a1699.js";
import { p as s, c as u } from "./decorators-7e9cd43b.js";
import "./class-map-31af68b2.js";
import { BaseElement as c } from "./BaseElement.esm.min.js";
import { h } from "./host.styles-cf05db22.js";
import { e as v } from "./event.decorator-98549cbc.js";
import "./interactive-icon.component.esm.min.js";
import { i as m } from "./if-defined-123567fc.js";
import "./types-814d68fb.js";
import { numberUndefinedConverter as y } from "./component.utils.esm.min.js";
import "./_commonjsHelpers-82e0321a.js";
import { g as b, l as f, i as k } from "./date-picker.utils-7bc542a5.js";
import "./date-picker-input-part.component-63342ded.js";
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const D = (e, t) => {
    const r = e.startNode.parentNode,
      n = void 0 === t ? e.endNode : t.startNode,
      o = r.insertBefore(a(), n);
    r.insertBefore(a(), n);
    const l = new i(e.options);
    return l.insertAfterNode(o), l;
  },
  z = (e, t) => (e.setValue(t), e.commit(), e),
  w = (e, t, i) => {
    const a = e.startNode.parentNode,
      n = i ? i.startNode : e.endNode,
      o = t.endNode.nextSibling;
    o !== n && r(a, t.startNode, o, n);
  },
  g = e => {
    n(e.startNode.parentNode, e.startNode, e.endNode.nextSibling);
  },
  P = (e, t, i) => {
    const a = new Map();
    for (let r = t; r <= i; r++) a.set(e[r], r);
    return a;
  },
  _ = new WeakMap(),
  j = new WeakMap(),
  E = t((e, t, a) => {
    let r;
    return void 0 === a ? a = t : void 0 !== t && (r = t), t => {
      if (!(t instanceof i)) throw new Error("repeat can only be used in text bindings");
      const n = _.get(t) || [],
        o = j.get(t) || [],
        l = [],
        d = [],
        p = [];
      let s,
        u,
        c = 0;
      for (const t of e) p[c] = r ? r(t, c) : c, d[c] = a(t, c), c++;
      let h = 0,
        v = n.length - 1,
        m = 0,
        y = d.length - 1;
      for (; h <= v && m <= y;) if (null === n[h]) h++;else if (null === n[v]) v--;else if (o[h] === p[m]) l[m] = z(n[h], d[m]), h++, m++;else if (o[v] === p[y]) l[y] = z(n[v], d[y]), v--, y--;else if (o[h] === p[y]) l[y] = z(n[h], d[y]), w(t, n[h], l[y + 1]), h++, y--;else if (o[v] === p[m]) l[m] = z(n[v], d[m]), w(t, n[v], n[h]), v--, m++;else if (void 0 === s && (s = P(p, m, y), u = P(o, h, v)), s.has(o[h])) {
        if (s.has(o[v])) {
          const e = u.get(p[m]),
            i = void 0 !== e ? n[e] : null;
          if (null === i) {
            const e = D(t, n[h]);
            z(e, d[m]), l[m] = e;
          } else l[m] = z(i, d[m]), w(t, i, n[h]), n[e] = null;
          m++;
        } else g(n[v]), v--;
      } else g(n[h]), h++;
      for (; m <= y;) {
        const e = D(t, l[y + 1]);
        z(e, d[m]), l[m++] = e;
      }
      for (; h <= v;) {
        const e = n[h++];
        null !== e && g(e);
      }
      _.set(t, l), j.set(t, p);
    };
  });
const $ = o`${l(":host {\n  --zui-date-picker-input-day-placeholder-width: calc(var(--zui-gu) * 2.5);\n  --zui-date-picker-input-month-placeholder-width: calc(var(--zui-gu) * 3);\n  --zui-date-picker-input-width: calc(var(--zui-gu) * 15);\n  --zui-date-picker-input-year-placeholder-width: calc(var(--zui-gu) * 3.75);\n  ---zui-date-picker-input-day-input-width: calc(var(--zui-gu) * 1.875);\n  ---zui-date-picker-input-month-input-width: calc(var(--zui-gu) * 1.875);\n  ---zui-date-picker-input-year-input-width: calc(var(--zui-gu) * 3.75);\n  align-items: center;\n  border-bottom: 1px solid var(--zui-color-input-bottom-line-default-enabled);\n  display: flex;\n  padding-bottom: calc(var(--zui-gu) * 0.125);\n  width: var(--zui-date-picker-input-width);\n}\n\n:host(:hover) {\n  border-bottom-color: var(--zui-color-input-bottom-line-default-hover);\n}\n\n:host(:focus-within) {\n  border-bottom-color: var(--zui-color-input-bottom-line-default-focused);\n}\n\n:host([invalid]),\n:host([invalid]):host(:focus-within),\n:host([invalid]:hover) {\n  border-bottom-color: var(--zui-color-error);\n}\n\n:host(:hover),\n:host(:focus-within),\n:host([invalid]) {\n  border-bottom-width: 2px;\n  padding-bottom: 0;\n}\n\n:host([readonly]) {\n  border-bottom-width: 0;\n  padding-bottom: 2px;\n}\n\n:host([disabled]) {\n  border-bottom-color: var(--zui-date-picker-input-border-bottom-disabled-color);\n  pointer-events: none;\n}\n\n.input-parts {\n  align-items: center;\n  display: flex;\n  min-width: 0;\n  width: 100%;\n}\n.input-parts .literal {\n  color: var(--zui-color-placeholder-input);\n  font: var(--zui-typography-body);\n}\n:host([disabled]) .input-parts .literal {\n  opacity: var(--zui-disabled-opacity);\n}\n:host([readonly]:not([selected-date])) .input-parts .literal {\n  color: transparent;\n  opacity: 0;\n}\n:host([selected-date]) .input-parts .literal, :host(:focus-within) .input-parts .literal {\n  color: var(--zui-color-text-default);\n}\n.input-parts zui-date-picker-input-part[input-part-type=day] {\n  ---zui-date-picker-input-part-input-width: var(---zui-date-picker-input-day-input-width);\n  --zui-date-picker-input-part-placeholder-width: var(--zui-date-picker-input-day-placeholder-width);\n}\n.input-parts zui-date-picker-input-part[input-part-type=month] {\n  ---zui-date-picker-input-part-input-width: var(---zui-date-picker-input-month-input-width);\n  --zui-date-picker-input-part-placeholder-width: var(--zui-date-picker-input-month-placeholder-width);\n}\n.input-parts zui-date-picker-input-part[input-part-type=year] {\n  ---zui-date-picker-input-part-input-width: var(---zui-date-picker-input-year-input-width);\n  --zui-date-picker-input-part-placeholder-width: var(--zui-date-picker-input-year-placeholder-width);\n}")}`,
  T = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  };
let V = class extends c {
  constructor() {
    super(...arguments), this.calendarOpened = !1, this.disabled = !1, this.focused = !1, this.invalid = !1, this.locale = b(), this.placeholderDay = "DD", this.placeholderMonth = "MM", this.placeholderYear = "YYYY", this.readonly = !1, this.selectedDate = null;
  }
  static get styles() {
    return [h, $];
  }
  get _selectedDateDT() {
    return this.selectedDate && f.DateTime.fromJSDate(this.selectedDate).isValid ? f.DateTime.fromJSDate(this.selectedDate) : void 0;
  }
  emitDatePickerInputCalendarSelectedEvent() {
    this.dispatchEvent(new CustomEvent("datePickerInputCalendarSelected", {
      bubbles: !0,
      composed: !0
    })), this.dispatchEvent(new CustomEvent("date-picker-input-calendar-selected", {
      bubbles: !0,
      composed: !0
    }));
  }
  emitDatePickerInputChangedEvent(e) {
    this.dispatchEvent(new CustomEvent("date-picker-input-changed", {
      bubbles: !0,
      composed: !0,
      detail: e
    }));
  }
  emitDatePickerInputFocusedEvent() {
    this.dispatchEvent(new CustomEvent("date-picker-input-focused", {
      bubbles: !0,
      composed: !0
    }));
  }
  get _dateTimeFormatParts() {
    return f.DateTime.now().toLocaleParts(Object.assign({
      locale: this.locale
    }, T));
  }
  get _inputParts() {
    var e;
    return (null === (e = this._selectedDateDT) || void 0 === e ? void 0 : e.isValid) ? this._selectedDateDT.toLocaleParts(Object.assign({
      locale: this.locale
    }, T)).map(e => "literal" === e.type ? e : Object.assign(Object.assign({}, e), {
      value: parseInt(e.value)
    })) : this._dateTimeFormatParts.map(e => Object.assign(Object.assign({}, e), {
      value: "literal" === e.type ? e.value : null
    }));
  }
  get _validLiterals() {
    const e = this._dateTimeFormatParts.filter(({
      type: e
    }) => "literal" === e).map(({
      value: e
    }) => e);
    return [...new Set(e)].join(",");
  }
  _handleDatePickerInputPartFocusEvent() {
    this.emitDatePickerInputFocusedEvent();
  }
  _handleDatePickerInputPartValueChangedEvent({
    detail: e
  }) {
    var t, i, a;
    const {
      type: r,
      value: n
    } = e;
    switch (r) {
      case "day":
        this.inputPartDayValue = null != n ? n : void 0;
        break;
      case "month":
        this.inputPartMonthValue = null != n ? n : void 0;
        break;
      case "year":
        this.inputPartYearValue = null != n ? n : void 0;
    }
    const o = {
        day: "day" === r ? n : this._selectedDateDT ? this._selectedDateDT.day : null !== (t = this.inputPartDayValue) && void 0 !== t ? t : null,
        month: "month" === r ? n : this._selectedDateDT ? this._selectedDateDT.month : null !== (i = this.inputPartMonthValue) && void 0 !== i ? i : null,
        year: "year" === r ? n : this._selectedDateDT ? this._selectedDateDT.year : null !== (a = this.inputPartYearValue) && void 0 !== a ? a : null
      },
      l = Object.values(o).includes(null),
      d = !l && f.DateTime.fromObject(Object.assign({}, o)).isValid;
    this.selectedDate = l ? null : f.DateTime.fromObject(Object.assign({}, o)).toJSDate(), this.emitDatePickerInputChangedEvent({
      value: this.selectedDate,
      error: d ? void 0 : o
    });
  }
  _handleShowCalendar() {
    this.emitDatePickerInputCalendarSelectedEvent();
  }
  updated(e) {
    super.updated(e), e.has("focused") && this.focused && console.warn("Deprecated focused property use detected. This will be removed in the next major version.");
  }
  render() {
    return d`<div class="input-parts">${E(this._inputParts, ({
      type: e,
      value: t
    }) => {
      var i, a, r, n, o, l;
      switch (e) {
        case "day":
          return d`<zui-date-picker-input-part ?disabled="${this.disabled}" ?readonly="${this.readonly}" input-part-type="day" literals="${this._validLiterals}" max="31" min="1" placeholder="${this.placeholderDay}" style="---zui-date-picker-input-part-input-width:var(---zui-date-picker-input-day-input-width);--zui-date-picker-input-part-placeholder-width:var(--zui-date-picker-input-day-placeholder-width)" value="${m(null !== (a = null === (i = this._selectedDateDT) || void 0 === i ? void 0 : i.day) && void 0 !== a ? a : this.inputPartDayValue)}" @date-picker-input-part-value-changed="${this._handleDatePickerInputPartValueChangedEvent}" @focus="${this._handleDatePickerInputPartFocusEvent}"></zui-date-picker-input-part>`;
        case "month":
          return d`<zui-date-picker-input-part ?disabled="${this.disabled}" ?readonly="${this.readonly}" input-part-type="month" literals="${this._validLiterals}" max="12" min="1" placeholder="${this.placeholderMonth}" style="---zui-date-picker-input-part-input-width:var(---zui-date-picker-input-month-input-width);--zui-date-picker-input-part-placeholder-width:var(--zui-date-picker-input-month-placeholder-width)" value="${m(null !== (n = null === (r = this._selectedDateDT) || void 0 === r ? void 0 : r.month) && void 0 !== n ? n : this.inputPartMonthValue)}" @date-picker-input-part-value-changed="${this._handleDatePickerInputPartValueChangedEvent}" @focus="${this._handleDatePickerInputPartFocusEvent}"></zui-date-picker-input-part>`;
        case "year":
          return d`<zui-date-picker-input-part ?disabled="${this.disabled}" ?readonly="${this.readonly}" input-part-type="year" literals="${this._validLiterals}" max="9999" min="1" placeholder="${this.placeholderYear}" style="---zui-date-picker-input-part-input-width:var(---zui-date-picker-input-year-input-width);--zui-date-picker-input-part-placeholder-width:var(--zui-date-picker-input-year-placeholder-width)" value="${m(null !== (l = null === (o = this._selectedDateDT) || void 0 === o ? void 0 : o.year) && void 0 !== l ? l : this.inputPartYearValue)}" @date-picker-input-part-value-changed="${this._handleDatePickerInputPartValueChangedEvent}" @focus="${this._handleDatePickerInputPartFocusEvent}"></zui-date-picker-input-part>`;
        case "literal":
          return d`<span class="literal">${t}</span>`;
        default:
          return p;
      }
    })}</div><zui-interactive-icon ?disabled="${this.disabled || this.readonly}" emphasis="default" @click="${this._handleShowCalendar}"><zui-icon-time-time-date-calender size="m"></zui-icon-time-time-date-calender></zui-interactive-icon>`;
  }
};
e([s({
  reflect: !0,
  type: Boolean,
  attribute: "calendar-opened"
})], V.prototype, "calendarOpened", void 0), e([s({
  reflect: !0,
  type: Boolean
})], V.prototype, "disabled", void 0), e([s({
  reflect: !0,
  type: Boolean
})], V.prototype, "focused", void 0), e([s({
  reflect: !0,
  type: Number,
  attribute: "input-part-day-value",
  converter: y
})], V.prototype, "inputPartDayValue", void 0), e([s({
  reflect: !0,
  type: Number,
  attribute: "input-part-month-value",
  converter: y
})], V.prototype, "inputPartMonthValue", void 0), e([s({
  reflect: !0,
  type: Number,
  attribute: "input-part-year-value",
  converter: y
})], V.prototype, "inputPartYearValue", void 0), e([s({
  reflect: !0,
  type: Boolean
})], V.prototype, "invalid", void 0), e([s({
  reflect: !0,
  type: String
})], V.prototype, "locale", void 0), e([s({
  reflect: !0,
  type: String,
  attribute: "placeholder-day"
})], V.prototype, "placeholderDay", void 0), e([s({
  reflect: !0,
  type: String,
  attribute: "placeholder-month"
})], V.prototype, "placeholderMonth", void 0), e([s({
  reflect: !0,
  type: String,
  attribute: "placeholder-year"
})], V.prototype, "placeholderYear", void 0), e([s({
  reflect: !0,
  type: Boolean
})], V.prototype, "readonly", void 0), e([s({
  reflect: !0,
  type: String,
  attribute: "selected-date",
  converter: k
})], V.prototype, "selectedDate", void 0), e([v()], V.prototype, "emitDatePickerInputCalendarSelectedEvent", null), e([v()], V.prototype, "emitDatePickerInputChangedEvent", null), e([v()], V.prototype, "emitDatePickerInputFocusedEvent", null), V = e([u("zui-date-picker-input")], V);
export { V as DatePickerInput };
